import React from "react"

export default function Button({
  as: Component = undefined,
  children,
  disabled = false,
  primary,
  secondary,
  dark,
  basic = false,
  className = "",
  ...props
}) {
  let classes = className
  // Add common class styles
  classes += " button py-2 px-4 font-bold "
  // Add styles according to button type
  if (disabled) {
    classes += "button-disabled "
  } else {
    if (primary) {
      classes += "button-primary "
    } else if (secondary) {
      classes += "button-secondary "
    } else if (dark) {
      classes += "button-dark "
    }
    // Add animation to button if not basic
    if (!basic && (primary || secondary || dark)) {
      classes += "button-animated "
    } else {
      classes += "button-basic "
    }
  }

  return Component ? (
    <Component className={classes} disabled={disabled} {...props}>
      {children}
    </Component>
  ) : (
    <button className={classes} disabled={disabled} {...props}>
      {children}
    </button>
  )
}
